<div class="">
  @for (entry of entries; track $index) {
    <div class="d-flex flex-nowrap udex-mb-8">
      @if (useBoxIcon) {
        <div class="custom-box-icon udex-me-8"></div>
      } @else {
        <ui5-icon class="icon udex-me-8" name="accept" accessible-name="Checked" aria-hidden="true"></ui5-icon>
      }
      <div class="d-flex flex-column body--s">
        @if (entry.name) {
          <span class="fw-bold text-black">{{ entry.name }}</span>
        }
        <span [innerHTML]="entry.value"></span>
      </div>
    </div>
  }
</div>
